import { Text } from '@mantine/core';
import clsx from 'clsx';

import { Checkbox } from '../checkbox/Checkbox';
import { GoogleFontIcon } from '../icons/GoogleFontIcon';

import { TableColumnSettings } from './TableCustomizationModal';

import styles from './table-customization.module.scss';

export type TableCustomizationItemProps = TableColumnSettings & {
  onChange: (id: string, isVisible: boolean) => void;
  showSortingHandle?: boolean;
};

export function TableCustomizationItem({
  id,
  label,
  isVisible,
  onChange,
  sublabel,
  showSortingHandle = true,
}: TableCustomizationItemProps) {
  return (
    <div
      className={clsx(
        styles['item'],
        showSortingHandle && styles['item--sortable']
      )}
    >
      <div
        className={styles['item__left']}
        onClick={() => onChange(id, !isVisible)}
      >
        <Checkbox checked={isVisible} />
      </div>
      <div className={styles['item__right']}>
        <Text
          classNames={{ root: styles['item__text'] }}
          onClick={() => onChange(id, !isVisible)}
        >
          {label}
          {sublabel && (
            <span className={styles['item__text__sublabel']}>{sublabel}</span>
          )}
        </Text>
        {showSortingHandle && (
          <GoogleFontIcon
            className={styles['item__reorder-symbol']}
            name="reorder"
          />
        )}
      </div>
    </div>
  );
}
